import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { MenuItem, TextField } from '@mui/material'

import { Analyst } from '../../../../../types/Analyst'
import { allAnalystsId } from '../../types/Dashboard'

type AnalystFilterSelectProps = {
  analysts: Analyst[]
  value: string
  onChange: (analystId: string) => void
}

export const AnalystFilterSelect: FC<AnalystFilterSelectProps> = ({ analysts, value, onChange }) => {
  const { t } = useTranslation()
  return (
    <TextField
      select
      size="small"
      label={t('internal-analysts:dashboard_filter_by_analyst')}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      sx={{ minWidth: 220 }}
    >
      <MenuItem value={allAnalystsId}>{t('internal-analysts:dashboard_all_analysts')}</MenuItem>
      {analysts.map((analyst) => (
        <MenuItem key={analyst.id} value={analyst.id}>
          {analyst.name}
        </MenuItem>
      ))}
    </TextField>
  )
}
